import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: { portalId: string; formId: string; target: string }) => void;
      };
    };
  }
}

export interface HubspotFormProps {
  portalId: string;
  formId: string;
}

const HubspotForm: React.FC<HubspotFormProps> = ({ portalId, formId }) => {
  const formRef = useRef<HTMLDivElement>(null); // Referenza per il contenitore del form

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: `#${formRef.current?.id}`,
        });
      }
    };
    document.body.appendChild(script);
  }, [portalId, formId]);

  return <div className="mx-auto" ref={formRef} id={`hubspot-form-${formId}`} />;
};

export default HubspotForm;
